// src/components/Vision.jsx
import React from "react";

const Vision = ({ imageSrc = "/vision.png" }) => {
  return (
    <section id="vision" className="vision">
      <div className="container">
        <div className="row align-items-center g-5">
          {/* Text (first on mobile, right on desktop) */}
          <div className="col-12 col-lg-6 order-1 order-lg-2">
            <div className="text-start mb-4 section-header">
              <span
                className="badge rounded-pill px-3 py-2 mb-2"
                style={{
                  background: "var(--chip)",
                  color: "var(--chiptext)",
                }}
              >
                Our Vision
              </span>
              <h2 className="mb-3" style={{ color: "var(--secondarytext)" }}>
                Pioneering the Future of Hardware Innovation
              </h2>
              <div className="divider"></div>
            </div>
            <p className="lead mb-0" style={{ color: "var(--secondarytext)", opacity: 0.9 }}>
              To be a global leader in smart hardware innovation—delivering
              sustainable, secure, and reliable products that scale from
              prototype to mass production.
            </p>

            {/* Additional vision points */}
            <div className="mt-4">
              <div className="d-flex align-items-center mb-2">
                <div className="me-3" style={{ color: "var(--primary)", fontSize: "1.5rem" }}>•</div>
                <p className="mb-0" style={{ color: "var(--secondarytext)" }}>
                  Creating technology that empowers industries and communities
                </p>
              </div>
              <div className="d-flex align-items-center mb-2">
                <div className="me-3" style={{ color: "var(--primary)", fontSize: "1.5rem" }}>•</div>
                <p className="mb-0" style={{ color: "var(--secondarytext)" }}>
                  Driving sustainable innovation through ethical manufacturing
                </p>
              </div>
              <div className="d-flex align-items-center">
                <div className="me-3" style={{ color: "var(--primary)", fontSize: "1.5rem" }}>•</div>
                <p className="mb-0" style={{ color: "var(--secondarytext)" }}>
                  Building hardware solutions that stand the test of time
                </p>
              </div>
            </div>
          </div>

          {/* Image (second on mobile, left on desktop) */}
          <div className="col-12 col-lg-6 order-2 order-lg-1">
            <div className="position-relative">
              <div
                aria-hidden="true"
                className="position-absolute top-0 start-0 translate-middle rounded-circle"
                style={{
                  width: 360,
                  height: 360,
                  background: "radial-gradient(circle, var(--primary-light) 0%, transparent 70%)",
                  opacity: 0.3,
                  zIndex: -1,
                }}
              />
              <img
                src={imageSrc}
                alt="Vision — smart, sustainable hardware"
                className="w-100 d-block rounded-4"
                style={{ objectFit: "cover", maxHeight: 460 }}
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </div>

      {/* small polish */}
      <style>{`
        .vision {
          padding: 6rem 0px;
          background: linear-gradient(to bottom, var(--canvas) 0%, white 100%);
        }

        .divider {
          width: 80px; 
          height: 4px; 
          background: var(--primary);
          border-radius: 999px; 
          margin: 0;
        }
        
        @media (max-width: 991.98px) {
          .divider { 
            margin-inline: auto; /* center divider on mobile */
          }
        }

        @media  screen and (max-width: 576px) {

        .vision{
          background-color: var(--error);
          padding: 1rem 0px;
        }
}

        
      `}</style>
    </section>
  );
};

export default Vision;
